import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-12 financial-calendar" }
const _hoisted_3 = { class: "card shadow-sm" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "card shadow-sm" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table table-striped table-bordered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query_month) = $event))
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['01','02','03','04','05','06','07','08','09','10','11','12'], (ind) => {
                    return _createElementVNode("option", {
                      key: ind,
                      value: ind
                    }, _toDisplayString(_ctx.moment('2021-' + ind + '-01 00:00:00').format('MMMM')), 9, _hoisted_5)
                  }), 64))
                ], 512), [
                  [_vModelSelect, _ctx.query_month]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query_year) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: year,
                      value: year
                    }, _toDisplayString(year), 9, _hoisted_6))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.query_year]
                ]),
                _withDirectives(_createElementVNode("select", {
                  class: "border-0 text-secondary me-2",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query_job_number) = $event))
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("option", { value: null }, "Select Job Number", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.job_numbers, (job_number, i) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: i,
                      value: job_number
                    }, _toDisplayString(job_number), 9, _hoisted_7))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.query_job_number]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-lg btn-primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getPaymentReport()))
                }, "Generate")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("table", _hoisted_11, [
                  _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Job Number"),
                      _createElementVNode("th", null, "Amount")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (value, label) => {
                      return (_openBlock(), _createElementBlock("tr", { key: label }, [
                        _createElementVNode("td", null, _toDisplayString(label), 1),
                        _createElementVNode("td", null, _toDisplayString(value), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ]))
}